import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const TimelineItemContainer = styled.div`
  display: flex;
  margin-bottom: 4rem;
  position: relative;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const TimelineDate = styled.div`
  width: 120px;
  text-align: ${props => props.alignment === 'left' ? 'right' : 'left'};
  padding: 0 20px;
  font-weight: 700;
  font-size: 1.5rem;
  color: #6c5ce7;
  
  @media (max-width: 768px) {
    width: 100%;
    text-align: left;
    margin-bottom: 1rem;
  }
`;

const TimelineContent = styled.div`
  flex: 1;
  background: white;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  margin-left: ${props => props.alignment === 'left' ? '60px' : '0'};
  margin-right: ${props => props.alignment === 'right' ? '60px' : '0'};
  
  @media (max-width: 768px) {
    margin-left: 0;
    margin-right: 0;
      max-height: 80%;
  }
`;

const TimelineImage = styled.div`
  height: 200px;
  background-size: cover;
  background-position: center;

    @media (min-width: 768px) {
        height: 600px;
        width: auto;
        background-size: inherit;
        background-position: center;
        background-color: #f1f1f1;
    }
`;

const TimelineText = styled.div`
  padding: 1.5rem;
  
  h3 {
    margin-bottom: 1rem;
    color: #333;
  }
  
  p {
    color: #666;
    line-height: 1.6;
  }
`;

const TimelineDot = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 20px;
  height: 20px;
  background-color: #6c5ce7;
  border-radius: 50%;
  z-index: 2;
  
  @media (max-width: 768px) {
    left: 10px;
    top: 0;
  }
`;

const TimelineItem = ({ year, title, description, image, alignment }) => {
    return (
        <TimelineItemContainer>
            {alignment === 'left' ? (
                <>
                    <TimelineDate alignment={alignment}>{year}</TimelineDate>
                    <TimelineDot />
                    <motion.div
                        style={{ flex: 1 }}
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5 }}
                    >
                        <TimelineContent alignment={alignment}>
                            <TimelineImage style={{ backgroundImage: `url(${image})` }} />
                            <TimelineText>
                                <h3>{title}</h3>
                                <p>{description}</p>
                            </TimelineText>
                        </TimelineContent>
                    </motion.div>
                </>
            ) : (
                <>
                    <motion.div
                        style={{ flex: 1 }}
                        initial={{ opacity: 0, x: 50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5 }}
                    >
                        <TimelineContent alignment={alignment}>
                            <TimelineImage style={{ backgroundImage: `url(${image})` }} />
                            <TimelineText>
                                <h3>{title}</h3>
                                <p>{description}</p>
                            </TimelineText>
                        </TimelineContent>
                    </motion.div>
                    <TimelineDot />
                    <TimelineDate alignment={alignment}>{year}</TimelineDate>
                </>
            )}
        </TimelineItemContainer>
    );
};

export default TimelineItem;